import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function widget_home_banner({ urls, slug, Image }) {
  const [data, setData] = useState(undefined);

  useEffect(() => {
    const { BASE_URL, WIDGETS_BASE } = urls;
    axios({ url: `${BASE_URL}${WIDGETS_BASE}${slug}/` }).then((res) => {
      setData(res.data.attributes);
    });
  }, [urls, slug]);

  return (
    <div className='container'>
      <div className='row'>
        {data &&
          data.items.map((item, i) => {
            const grid = 2;
            const gridClass = 'col-md-' + parseInt(12 / grid, 10);
            return (
              <div key={i} className={`col-12 col-sm-12 ${gridClass}`}>
                <Link
                  to={`products${item.value.url}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <div className='home__banner'>
                    <Image src={item.kwargs.value.image.url} />
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default widget_home_banner;



// WEBPACK FOOTER //
// ./src/plugins/tfs/platformConfigs/widgets/widget_home_banner/index.js